import { Connection1cCredentialsDto, type Connection1cCredentialsInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-credentials.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { IntergrationDtoKeyEnum } from '@zaoblako/shared/modules/integration/enums/intergration-dto-key.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';

import * as yup from 'yup';

/** 1C ERP database connection credentials create or update request body */
export interface Connection1cFormInterface extends Connection1cCredentialsInterface {
  /** Connection display name */
  name: string;
  /** Is the exchange disabled for this 1C ERP database? */
  disabled: boolean;
}

/** 1C ERP database connection credentials create or update request body - DTO schema */
export const Connection1cFormDto = SerdeDtoClass.from<Connection1cCredentialsInterface, Connection1cFormInterface>(
  Connection1cCredentialsDto,
  IntergrationDtoKeyEnum.CONNECTION_1C_FORM_DTO,
  {
    name: {
      sortable: true,
      label: 'Название',
      serializer: yup
        .string()
        .min(1, DtoMessageEnum.EMPTY_STRING),
    },
    disabled: {
      label: 'Отключить от обмена',
      serializer: yup.boolean(),
    },
  },
);
